import { render, staticRenderFns } from "./SelectTimeLimit.vue?vue&type=template&id=58df275c&"
import script from "./SelectTimeLimit.vue?vue&type=script&lang=js&"
export * from "./SelectTimeLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58df275c')) {
      api.createRecord('58df275c', component.options)
    } else {
      api.reload('58df275c', component.options)
    }
    module.hot.accept("./SelectTimeLimit.vue?vue&type=template&id=58df275c&", function () {
      api.rerender('58df275c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SelectTimeLimit.vue"
export default component.exports